<div id="sandhub-workarea">
  <div class="title-bar-area">
    <div class="title-area">Data Labs</div>
    <!--<div class="video-icon" (click)="openPopup()"><i class="far fa-video"></i></div>
    <app-video-modal *ngIf="showPopup==true" [videoUrl]="videoDetail" (closeVideoPopup)="closeVideoPopup($event)"></app-video-modal>-->
  </div>
</div>

<div class="datalabs-container">
  <div class="datalabs-header">Welcome to the Data Labs homepage.  We are pleased to offer a range of services that enable you to provide compelling insights and data to our clients.  Our services include:</div>
  <div class="datalabs-offering-container">
    <div class="datalabs-offering-card">
      <div class="datalabs-offering-card-image">
        <img src="../assets/images/workbench/experts/datalabs/ratecard.png" alt="An image of a ratecard" />
      </div>
      <div class="datalabs-offering-card-title">Rate Card</div>
    </div>
    <div class="datalabs-offering-card">
      <div class="datalabs-offering-card-image">
        <img src="../assets/images/workbench/experts/datalabs/itmetrics.png" alt="An image of IT metrics" />
      </div>
      <div class="datalabs-offering-card-title">IT Metrics</div>
    </div>
    <div class="datalabs-offering-card">
      <div class="datalabs-offering-card-image">
        <img src="../assets/images/workbench/experts/datalabs/pricing.png" alt="An image representing pricing" />
      </div>
      <div class="datalabs-offering-card-title">Pricing, Contract Artifacts, SLAs</div>
    </div>
    <div class="datalabs-offering-card">
      <div class="datalabs-offering-card-image">
        <img src="../assets/images/workbench/experts/datalabs/other.png" alt="An image representing other" />
      </div>
      <div class="datalabs-offering-card-title">Other</div>
    </div>
  </div>
  <div class="datalabs-body"><a href="https://forms.office.com/Pages/ResponsePage.aspx?id=M-_HohYB_EWk8b_HT4j_rKBT2Eo0yCdBs8Y-m2bbYxBUMlE5RTNITEFSVVVNOVY5N0M1WlRUSklCQiQlQCN0PWcu" rel="noopener" target="_blank"><span class="teal link"> Click here</span></a> to launch a digital form that captures what we need to address your request.</div>   <!--  Once you’ve submitted your request, come back to this page at any time to check on its status-->
</div>


